export const serviceCenterEmail = 'ContactUs@tabtouch.com.au'
